module.exports = __webpack_public_path__ + "img/p2p-fill.64bee355.svg";